@if(showLabel) {
<div
  data-e2e="p-card-info-title"
  class="overflow-hidden style-id-title p-card-info-title"
>
  <span i18n="PCard|Product style id property title@@pcardStyleIdTitle"
    >style id</span
  >
</div>
} @if (product | productTitle: { fields: idFields }; as productId) {
<div
  [title]="formattedProductId || productId"
  class="pcard-header-value font-weight-bold w-100 p-card-info-value"
>
  <span
    data-e2e="p-card-title-id"
    class="pcard-title-id text-truncate d-inline-block"
    [atxTooltip]="copyIdText"
    [tooltipPlacement]="tooltipPlacement"
    [cdkCopyToClipboard]="formattedProductId || productId"
    (cdkCopyToClipboardCopied)="copiedToClipboard($event)"
    (click)="$event.stopPropagation()"
    >{{ formattedProductId || productId }}</span
  >
</div>
}
